export const container_support_index = ['container_support.index']
export const container_support_create = ['container_support.create']
export const container_support_edit = ['container_support.edit']

export default [].concat(
    container_support_index,
    container_support_create,
    container_support_edit
)
